export default "__VITE_ASSET__ejQhmtDetZoQqEyqldqvEA__"